import React from 'react';
import { ActionsContainer, FiltersContainer } from '../styled';
import DropdownSelect from '../../../components/DropdownSelect';
import { academicYears } from '../../../constants/academicYears';
import { StyledButton } from '../../CashFlowStatement/styled'; // Reusing StyledButton
import CircularProgress from '@mui/material/CircularProgress';
import { PaperWrapper } from '../../common/styled';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { usersWithRolloverDashboardAccess } from '../../../constants/superAdminUsers';

interface SearchFiltersProps {
  academicYear: string;
  loading: boolean;
  isDownloading: boolean;
  onAcademicYearChange: (value: string) => void;
  onSearch: () => void;
  onDownload: () => void;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({
  academicYear,
  loading,
  isDownloading,
  onAcademicYearChange,
  onSearch,
  onDownload
}) => {
  const { user } = useSelector((state: RootState) => state.profile);
  const hasRolloverAccess = usersWithRolloverDashboardAccess.includes(
    user?.email || ''
  );

  return (
    <PaperWrapper>
      <FiltersContainer>
        <DropdownSelect
          label='Rollover Academic year'
          placeholder='Select Academic Year'
          name='academicYear'
          value={academicYear}
          onChange={(e) => onAcademicYearChange(e.target.value as string)}
          options={academicYears.map((y) => ({
            label: y.label,
            value: y.value
          }))}
          required
        />
      </FiltersContainer>
      <ActionsContainer>
        <StyledButton
          variant='contained'
          color='primary'
          onClick={onSearch}
          disabled={loading || isDownloading || !hasRolloverAccess}
        >
          {loading ? <CircularProgress size={24} color='inherit' /> : 'View'}
        </StyledButton>
        <StyledButton
          variant='contained'
          color='primary'
          onClick={onDownload}
          disabled={loading || isDownloading || !hasRolloverAccess}
        >
          {isDownloading ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            'Download'
          )}
        </StyledButton>
      </ActionsContainer>
    </PaperWrapper>
  );
};

export default SearchFilters;
